// extracted by mini-css-extract-plugin
export default {"form":"AddBlog_form__5t9Fk","spacing":"AddBlog_spacing__BDUke","widthHalfPage":"AddBlog_widthHalfPage__QsePn"};